import type { IVendor } from "../../../../types/models/vendor.modals.types";
import { usePostHttp } from "../../http.hook";

export enum VendorType {
  INDIVIDUAL = "individual",
  AGENCY = "agency",
}

interface IBody {
  name: string;
  email: string;
  phoneNumber: string;
  vendorType: VendorType;
}

interface IResponse {
  vendor: IVendor;
}

export function useCreateVendorHttp() {
  return usePostHttp<IBody, IResponse>({
    path: "/admin/vendors",
  });
}
